<template>
    <div class="relative overflow-hidden bg-gradient-to-br from-slate-900 via-slate-900 to-primary-950 py-16 sm:py-24">
        <div class="pointer-events-none absolute -top-16 right-0 -z-0 h-72 w-72 rounded-full bg-primary-500 opacity-20 blur-3xl"
            aria-hidden="true"></div>
        <div class="pointer-events-none absolute bottom-0 left-0 -z-0 h-72 w-72 rounded-full bg-secondary-500 opacity-20 blur-3xl"
            aria-hidden="true"></div>
        <div class="relative mx-auto max-w-7xl px-6 lg:px-8">
            <dl class="grid grid-cols-1 gap-x-8 gap-y-12 text-center sm:grid-cols-3">
                <div v-for="stat in stats" :key="stat.id" class="mx-auto flex max-w-xs flex-col items-center gap-y-4">
                    <div class="flex size-14 items-center justify-center rounded-2xl bg-white/10 text-primary-300 ring-1 ring-white/10">
                        <component :is="stat.icon" class="size-7" aria-hidden="true" />
                    </div>
                    <dd class="text-4xl font-bold tracking-tight text-white sm:text-5xl">{{ stat.value }}</dd>
                    <dt class="text-base/7 text-slate-300">{{ stat.name }}</dt>
                </div>
            </dl>
        </div>
    </div>
</template>

<script setup>
import { AcademicCapIcon, BookOpenIcon, GlobeAltIcon } from '@heroicons/vue/24/outline';

const stats = [
    { id: 0, name: 'Students enrolled', value: '1M+', icon: AcademicCapIcon },
    { id: 1, name: 'Courses available', value: '500+', icon: BookOpenIcon },
    { id: 3, name: 'Languages supported', value: '5', icon: GlobeAltIcon },
]
</script>
